
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.25 9a.75.75 0 01-.75-.75v-3a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75h-3zM7.5 7.5V6H6v1.5h1.5zM5.25 19.5a.75.75 0 01-.75-.75v-3a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75h-3zM7.5 18v-1.5H6V18h1.5zM15.75 9a.75.75 0 01-.75-.75v-3a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v3a.75.75 0 01-.75.75h-3zM18 7.5V6h-1.5v1.5H18zM11.25 15a.75.75 0 01-.75-.75v-.75H5.25a.75.75 0 010-1.5h6a.75.75 0 01.75.75v1.5a.75.75 0 01-.75.75zM14.25 19.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0V18h3v-3h-.75a.75.75 0 010-1.5h1.5a.75.75 0 01.75.75v4.5a.75.75 0 01-.75.75h-4.5zM11.25 19.5a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0v1.5a.75.75 0 01-.75.75zM11.25 10.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 011.5 0V9h.75a.75.75 0 010 1.5h-1.5zM15.75 12a.75.75 0 010-1.5h3a.75.75 0 010 1.5h-3zM.75 6.75A.75.75 0 010 6V2.25A2.252 2.252 0 012.25 0H6a.75.75 0 010 1.5H2.25a.75.75 0 00-.75.75V6a.75.75 0 01-.75.75zM23.25 6.75A.75.75 0 0122.5 6V2.25a.75.75 0 00-.75-.75H18A.75.75 0 0118 0h3.75A2.252 2.252 0 0124 2.25V6a.75.75 0 01-.75.75zM18 24a.75.75 0 010-1.5h3.75a.75.75 0 00.75-.75V18a.75.75 0 011.5 0v3.75A2.252 2.252 0 0121.75 24H18zM2.25 24A2.252 2.252 0 010 21.75V18a.75.75 0 011.5 0v3.75c0 .414.336.75.75.75H6A.75.75 0 016 24H2.25z"}})])
          )
        }
      }
    